<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-card>
          <div class="text-muted mb-50">Finans Bakiyesi</div>
          <h3 :class="summary.balance >= 0 ? 'text-success' : 'text-danger'">
            {{ signed(summary.balance) }} USDT
          </h3>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <div class="text-muted mb-50">Toplam Realize PnL</div>
          <h3 :class="summary.totalRealizedPnl >= 0 ? 'text-success' : 'text-danger'">
            {{ signed(summary.totalRealizedPnl) }} USDT
          </h3>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card>
          <div class="text-muted mb-50">Bugün PnL</div>
          <h3 :class="summary.todayPnl >= 0 ? 'text-success' : 'text-danger'">
            {{ signed(summary.todayPnl) }} USDT
          </h3>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="4">
        <b-card title="Bakiye Hareketi">
          <b-form-group label="İşlem">
            <b-form-select
              v-model="form.type"
              :options="typeOptions"
            />
          </b-form-group>
          <b-form-group label="Tutar">
            <b-form-input
              v-model.number="form.amount"
              type="number"
              min="0"
              step="0.0001"
            />
          </b-form-group>
          <b-form-group label="Açıklama">
            <b-form-input
              v-model="form.reason"
              placeholder="Opsiyonel"
            />
          </b-form-group>
          <b-alert
            v-if="saveStatus.message"
            :variant="saveStatus.status ? 'success' : 'danger'"
            show
          >
            {{ saveStatus.message }}
          </b-alert>
          <b-button
            variant="primary"
            block
            :disabled="saving"
            @click="submitManualEntry"
          >
            Kaydet
          </b-button>
        </b-card>
      </b-col>

      <b-col lg="8">
        <b-card title="Finans Defteri">
          <b-table
            :items="entries"
            :fields="fields"
            small
            striped
            responsive
            show-empty
            empty-text="Henüz finans hareketi yok."
          >
            <template #cell(occurredAt)="data">
              <small>{{ formatDateTime(data.item.occurredAt) }}</small>
            </template>
            <template #cell(type)="data">
              <b-badge :variant="typeVariant(data.item.type)">
                {{ typeLabel(data.item.type) }}
              </b-badge>
            </template>
            <template #cell(amount)="data">
              <strong :class="data.item.amount >= 0 ? 'text-success' : 'text-danger'">
                {{ signed(data.item.amount) }}
              </strong>
            </template>
            <template #cell(symbol)="data">
              <div>{{ data.item.symbol || '-' }}</div>
              <small class="text-muted">{{ data.item.botName || data.item.targetName || '' }}</small>
            </template>
            <template #cell(pnl)="data">
              <span
                v-if="data.item.pnl !== null"
                :class="data.item.pnl >= 0 ? 'text-success' : 'text-danger'"
              >
                {{ signed(data.item.pnl) }}
              </span>
              <span
                v-else
                class="text-muted"
              >-</span>
            </template>
          </b-table>
          <b-pagination
            v-if="meta.totalPages > 1"
            v-model="page"
            :total-rows="meta.total"
            :per-page="meta.limit"
            align="right"
            class="mb-0"
            @input="fetchEntries"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'

export default {
  name: 'FinanceIndex',
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BPagination,
    BRow,
    BTable,
  },
  data() {
    return {
      saving: false,
      page: 1,
      form: {
        type: 'DEPOSIT',
        amount: null,
        reason: '',
      },
      typeOptions: [
        { value: 'INITIAL_BALANCE', text: 'Başlangıç Bakiyesi' },
        { value: 'DEPOSIT', text: 'Bakiye ekle' },
        { value: 'WITHDRAWAL', text: 'Bakiye çek' },
        { value: 'ADJUSTMENT', text: 'Düzeltme' },
      ],
      fields: [
        { key: 'occurredAt', label: 'Zaman' },
        { key: 'type', label: 'Tip' },
        { key: 'symbol', label: 'Bağlam' },
        { key: 'amount', label: 'Bakiye Etkisi' },
        { key: 'pnl', label: 'PnL' },
        { key: 'reason', label: 'Açıklama' },
      ],
    }
  },
  computed: {
    summary() {
      return this.$store.getters['finance/summary'] || {
        balance: 0,
        totalRealizedPnl: 0,
        todayPnl: 0,
      }
    },
    entries() { return this.$store.getters['finance/entries'] || [] },
    meta() {
      return this.$store.getters['finance/metaData'] || {
        total: 0,
        page: 1,
        limit: 50,
        totalPages: 0,
      }
    },
    saveStatus() {
      return this.$store.getters['finance/dataSaveStatus'] || { status: null, message: null }
    },
  },
  created() {
    this.fetchAll()
  },
  methods: {
    fetchAll() {
      this.$store.dispatch('finance/getSummary')
      this.fetchEntries()
    },
    fetchEntries() {
      return this.$store.dispatch('finance/getEntries', {
        page: this.page,
        limit: 50,
      })
    },
    submitManualEntry() {
      if (!Number(this.form.amount)) return
      this.saving = true
      this.$store.dispatch('finance/createManualEntry', {
        type: this.form.type,
        amount: Number(this.form.amount),
        reason: this.form.reason,
      }).then(() => {
        this.form.amount = null
        this.form.reason = ''
        this.page = 1
        this.fetchAll()
      }).finally(() => {
        this.saving = false
      })
    },
    signed(value) {
      const n = Number(value || 0)
      return `${n >= 0 ? '+' : ''}${n.toFixed(4)}`
    },
    formatDateTime(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('tr-TR')
    },
    typeLabel(type) {
      if (type === 'INITIAL_BALANCE') return 'Başlangıç'
      if (type === 'DEPOSIT') return 'Giriş'
      if (type === 'WITHDRAWAL') return 'Çekim'
      if (type === 'TRADE_ENTRY') return 'Entry'
      if (type === 'TRADE_EXIT') return 'Exit'
      if (type === 'PARTIAL_EXIT') return 'Partial'
      return 'Düzeltme'
    },
    typeVariant(type) {
      if (type === 'INITIAL_BALANCE') return 'primary'
      if (type === 'DEPOSIT') return 'success'
      if (type === 'WITHDRAWAL') return 'danger'
      if (type === 'TRADE_ENTRY') return 'info'
      if (type === 'TRADE_EXIT' || type === 'PARTIAL_EXIT') return 'warning'
      return 'secondary'
    },
  },
}
</script>
